import React from 'react';
import { CheckoutSummaryProps } from '../types/components';

const CheckoutSummary = ({
    totalDiscountCoupon,
    total,
    products,
    onRemoveGeneralCoupon,
    onRemoveProductCoupon,
}: CheckoutSummaryProps) => {
    // Obtener cupones únicos de productos (sin duplicados)
    const productCoupons = products?.reduce((uniqueCoupons: string[], product: any) => {
        if (product.coupon && product.amountDiscount > 0 && !uniqueCoupons.includes(product.coupon)) {
            uniqueCoupons.push(product.coupon);
        }
        return uniqueCoupons;
    }, []) || [];

    const handleRemoveGeneralCoupon = () => {
        if (onRemoveGeneralCoupon) {
            onRemoveGeneralCoupon();
        }
    };

    const handleRemoveProductCoupon = (couponCode: string) => {
        if (onRemoveProductCoupon) {
            onRemoveProductCoupon(couponCode);
        }
    };

    return (
        <div className="form-group mt-3">
            <h5 className="mb-2">Cupones</h5>

            {/* Bloque para cupones general y de productos */}
            <div className="d-flex flex-wrap gap-2 mb-3">
                {/* Cupón general */}
                {totalDiscountCoupon.discount && (
                    <div
                        className="badge bg-primary d-flex align-items-center"
                        style={{ padding: '0.5em 0.75em', fontSize: '0.9em' }}
                    >
                        <span>{`Cupón General: ${totalDiscountCoupon.code || 'Descuento Manual'}`}</span>
                        <button
                            type="button"
                            onClick={handleRemoveGeneralCoupon}
                            className="btn-close btn-close-white btn-sm ms-2"
                            aria-label="Eliminar cupón general"
                            style={{ cursor: 'pointer' }}
                        ></button>
                    </div>
                )}

                {/* Cupones de productos */}
                {productCoupons.map((coupon) => (
                    <div
                        key={coupon}
                        className="badge bg-primary d-flex align-items-center"
                        style={{ padding: '0.5em 0.75em', fontSize: '0.9em' }}
                    >
                        <span>{coupon}</span>
                        <button
                            type="button"
                            onClick={() => handleRemoveProductCoupon(coupon)}
                            className="btn-close btn-close-white btn-sm ms-2"
                            aria-label={`Eliminar cupón ${coupon}`}
                            style={{ cursor: 'pointer' }}
                        ></button>
                    </div>
                ))}
            </div>
            <h5 className="mb-2">Detalles Generales</h5>

            {/* Total final */}
            <input
                type="text"
                className="form-control mt-2"
                value={`Total de la Compra: S/.${total.toFixed(2)}`}
                readOnly
            />
        </div>
    );
};

export default CheckoutSummary;
